import { useSelector } from 'react-redux';
import { RootState } from '../redux';
import { HRMSUserType, UserType } from '../types/auth';

const useUser = (): UserType => {
    const { user } = useSelector((state: RootState) => state.user);
    const hasUser = user as UserType;

    return hasUser && hasUser;
};

export const useHRMSUser = (): HRMSUserType => {
    const { hrmsUser } = useSelector((state: RootState) => state.HRMSUser);
    const hasHRMSUser = hrmsUser as HRMSUserType;

    return hasHRMSUser;
};

export const useCOESettings = () => {
    const COEsettings = useSelector((state: RootState) => state.COEonboardingReviewsFlow);

    return COEsettings;
};

export const usePolicy = () => {
    const policy = useSelector((state: RootState) => state.policy);

    return policy;
};

export const useExitReviewFlow = () => {
    const settings = useSelector((state: RootState) => state.onboardingExitReviewsFlow);

    return settings;
};

export const useForceSignOutFlow = () => {
    const { value } = useSelector((state: RootState) => state.forceSignOutSliceFlow);

    return value;
};

export const useOnboardReviewEditableFlow = () => {
    const settings = useSelector((state: RootState) => state.onboardingReviewsEditableFlow);

    return settings;
};

export const useCOEReviewFlow = () => {
    const COEonboardWorkFlowSettings = useSelector((state: RootState) => state.COEonboardingReviewsFlow);

    return COEonboardWorkFlowSettings;
};

export const useUserLoading = () => {
    const data = useSelector((state: RootState) => state.user);

    return data;
};
export const useHRMSUserLoading = () => {
    const data = useSelector((state: RootState) => state.HRMSUser);

    return data;
};

export const useConsentFlow = () => {
    const consentWorkFlowSettings = useSelector((state: RootState) => state.consentWorkFlow);

    return consentWorkFlowSettings;
};

export const useUserProfile = () => {
    const userProfile = useSelector((state: RootState) => state.registration.profile);

    return userProfile;
};

export const useKYCDigioSignFlow = () => {
    const kycDigioSignFlowSettings = useSelector((state: RootState) => state.KYCDigioSignFlow);

    return kycDigioSignFlowSettings;
};

export const useCount = () => {
    const useCount = useSelector((state: RootState) => state.toolkit.count);

    return useCount;
};

export const useTodos = () => {
    const useTodos = useSelector((state: RootState) => state.toolkit.todos);

    return useTodos;
};

export const usePhoneCode = () => {
    const useTodos = useSelector((state: RootState) => state.phoneCodeOpenApi);

    return useTodos;
};

export default useUser;
